export const getDashboardCityPlans = cityPlans =>
  cityPlans.map(({ id, city }) => ({ id, cityName: city.name }))
